import Component from '../abstracts/Component';
import { gregorian } from '@pacote/computus';


/**
 * Date picker component
 */
export default class DatePickerComponent extends Component {
  get SELECTORS () {
    return {
      datepicker: '[data-calendar="true"], .js-datepicker',
      datepickerModal: '.vex [data-calendar="true"], .vex .js-datepicker',
      returnOrderProceed: '.js-proceed-to-confirm',
      dateOfBirth: '.js-dateofbirth',
      customDate: '.custom-date'
    };
  }

  dateFormatByCountry() {
    // Korea: Y-M-D , US : M-D-Y, EU: D-M-Y
    let currentCountry = document.body.dataset.website;
    let dateFormat = '';

    switch (currentCountry) {
      case 'it':
        dateFormat = 'd-m-Y';
        break;
      case 'us':
        dateFormat = 'm-d-Y';
        break;
      default:
        dateFormat = 'd-m-Y';
    }

    return dateFormat;
  }

  today() {
    let todayTime = new Date();
    let dd = todayTime.getDate();
    let mm = todayTime.getMonth() + 1;
    let yyyy = todayTime.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
    }

    if (mm < 10) {
      mm = '0' + mm;
    }

    let format = this.dateFormatByCountry();
    let today = '';

    switch (format) {
      case 'd-m-Y':
        today = dd + '/' + mm + '/' + yyyy;
        break;
      case 'm-d-Y':
        today = mm + '/' + dd + '/' + yyyy;
        break;
      case 'Y-m-d':
        today = yyyy + '/' + mm + '/' + dd;
        break;
      default:
        today = dd + '/' + mm + '/' + yyyy;
    }

    return today;
  }

  initDatepicker(flatpickr, localization, check) {
    let ctx = this;
    let _dateFormat = ctx.dateFormatByCountry();

    $(check).each(function() {
      let _this = $(this);
      let isStatic = false;
      let mindate = null;
      let maxdate = null;
      let dateFormatCustom = null;
      let defaultDate = Date.parse($(this).data('defaultDate'));
      let disableweekends = $(this).data('disableweekends') || false;
      let isKr = document.body.dataset.website === 'kr';
      let isAdult = $(this).data('adultValidation');

      mindate = Date.parse($(this).data('mindate'));
      maxdate = Date.parse($(this).data('maxdate'));
      dateFormatCustom = $(this).data('dateFormat');

      if (disableweekends) {

        var isGLSOrder = document.getElementById("isGLSOrder");
        var country = $("body").data("website");
        var isCountryIT = country != null && country.toLowerCase() === 'it';
        if ((typeof(isGLSOrder) != 'undefined' && isGLSOrder != null && isGLSOrder.value === 'true') || isCountryIT) {
          var currentEasterDate = gregorian(new Date().getFullYear());
          var currentEasterMondayDate = new Date(currentEasterDate);
          currentEasterMondayDate.setDate(currentEasterDate.getDate() + 1);
          var currentEasterMonday = (currentEasterMondayDate.getDate()) + '/' + (currentEasterMondayDate.getMonth() + 1);
        }
        _this.flatpickr({
          static: isStatic ? isStatic : false,
          disableMobile: 'true',
          dateFormat: dateFormatCustom == null ? 'Y-m-d' : dateFormatCustom,
          altInput: true,
          altFormat: _dateFormat,
          altInputClass: 'custom-date',
          minDate: mindate,
          maxDate: maxdate,
          allowInput: false,

          onChange: function(dateObj, dateStr, instance) {
            if ($('input[name=hourpick]').is(':checked')) {
              $(ctx.SELECTORS.returnOrderProceed).removeClass('disabled');
            }
          },
          animate: false,
          disable: [
            function(date) {
              var exclude = ['1/1', '6/1', '25/4', '1/5', '2/6', '15/8', '1/11', '8/12', '25/12', '26/12', currentEasterMonday];
              var d = date.getDate();
              var m = date.getMonth();
              var dayExclude = d + '/' + (m+1);
              return (date.getDay() === 6 || date.getDay() === 0 || ~$.inArray(dayExclude, exclude));
            }
          ],
          locale: localization
        });
        const hourpickSelected = $('#hourpickSelected').val();
        if (hourpickSelected) {
          $('#hourpick').val(hourpickSelected);
        }
      } else if ($(this).hasClass('js-dateofbirth')) {
        // no default on current date
        _this.flatpickr({
          static: false,
          disableMobile: 'true',
          dateFormat: dateFormatCustom == null ? 'Y-m-d' : dateFormatCustom,//output format
          altInput: true,
          altFormat: _dateFormat,//display format
          altInputClass: 'custom-date',
          minDate: mindate,
          maxDate: maxdate,
          allowInput: true,
          locale: localization,
          parseDate: function(datestr, format) {
              var regex = /^\d{4}[-]\d{2}[-]\d{2}$/;//xxxx-xx-xx
              if(regex.test(datestr)){//value coming from BE
                return new Date(datestr.substring(0, 4), datestr.substring(5, 7) - 1, datestr.substring(8, 10));
              }
              let date = null;
              const parsedValue = datestr.replaceAll("-","").replaceAll("/","").replaceAll(".","");
              if (parsedValue.length === 8) {
                switch (format) {
                  case 'm-d-Y':
                    date = new Date(parsedValue.substring(4, 8), parsedValue.substring(0, 2) - 1, parsedValue.substring(2, 4));
                    break;
                  case 'Y-m-d':
                    date = new Date(parsedValue.substring(0, 4), parsedValue.substring(6, 8) - 1, parsedValue.substring(4, 6));
                    break;
                  case 'd-m-Y':
                  default:
                    date = new Date(parsedValue.substring(4, 8), parsedValue.substring(2, 4) - 1, parsedValue.substring(0, 2));
                    break;
                }
              }
              //Salesforce max date range
              let mindatesf = new Date(1700,1,1);
              let maxdatesf = new Date(4000,12,31);
              if (!(date instanceof Date) || isNaN(date) || date < mindatesf || date > maxdatesf) {
                $($(ctx.SELECTORS.dateOfBirth)[1]).addClass("error");
              } else {
                $($(ctx.SELECTORS.dateOfBirth)[1]).removeClass("error");
              }
              return date;
            },
            onReady: function(selectedDates, dateStr, instance) {
                let altInput = instance.altInput;
                altInput.classList.add("js-dateofbirth");

                altInput.addEventListener('change', function() {

                    $(altInput).valid();

                });
                altInput.addEventListener('blur', function() {
                    $(altInput).valid();
                });
              }
        });
      } else {
        _this.flatpickr({
          static: isStatic ? isStatic : false,
          disableMobile: 'true',
          altInput: true,
          altFormat: _dateFormat,
          dateFormat: 'Y-m-d',
          altInputClass: 'custom-date',
          minDate: mindate,
          maxDate: maxdate,
          allowInput: false,
          locale: localization
        });
      }
    });
  }

  getLocalization(lang) {
    switch (lang) {
      case 'en':
        return 'default';
      default:
        return lang;
    }
  }

  render() {
    this.log('Rendering...');
    let lang = this.getLocalization($('html').attr('lang'));
    this.moduleLoader.loadFlatpickr(module => {
      this.moduleLoader.loadFlatpickrLocale(lang, (localization) => {
          this.initDatepicker(module.default, lang, this.SELECTORS.datepicker);
          this.bindEvents(module.default, lang, this.SELECTORS)
          this.setMaxLengthBirthDatePicker();
        },
        err => console.warn('cant load flatpickr')
      );
    });
  }

  bindEvents(moduled,lang,selectors) {
    this.$on(this.$customEvents.MODAL_EVENTS.afterOpen, () => {
      this.log('Setup for modals');
      this.initDatepicker(moduled, lang, selectors.datepickerModal);
    });

    this.$on(this.$customEvents.MODAL_EVENTS.afterUpdateContent, () => {
      this.log('Setup for modals');
      this.initDatepicker(moduled, lang, selectors.datepickerModal);
    });

    this.$on(this.$customEvents.PAGE_LAYOUT_EVENTS.changed, () => {
      this.log('Setup for html edit');
      this.initDatepicker(moduled, lang, selectors.datepicker);
    });

    const ctx = this;
    if ($(ctx.SELECTORS.dateOfBirth)[1]) {
      $(ctx.SELECTORS.dateOfBirth)[1].onkeydown = function(e) {
        return ctx.isNumeric(this, e.key, /* isShift */ false);
      }

      $(ctx.SELECTORS.dateOfBirth)[1].onkeyup = function(e) {
        ctx.validateDateFormat(this);
      }
    }
  }

  isNumeric(input, keyCode, isShift) {
    let acceptableKeys = ['0','1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'ArrowRight', 'ArrowLeft'];
    isShift = false;
    let seperator = '-'
    if (keyCode == 'ShiftLeft'|| keyCode == 'ShiftRight') {
      isShift = true;
    }
    //Allow only numeric keys
    if (acceptableKeys.includes(keyCode) && isShift == false) {
      if ((input.value.length == 2 || input.value.length == 5) && keyCode != 'Backspace') {
        input.value += seperator;
      }
      return true;
    }
    else {
      return false;
    }
  }

  validateDateFormat(input) {
    const format = this.dateFormatByCountry();
    let value = input.value.replace(/\D/g, '');
    let formattedValue = '';

    if (format === 'Y-m-d') {
        if (value.length > 4) {
            formattedValue = value.substring(0, 4) + '-';
            if (value.length > 6) {
                formattedValue += value.substring(4, 6) + '-';
                formattedValue += value.substring(6, 8);
            } else {
                formattedValue += value.substring(4);
            }
        } else {
            formattedValue = value;
        }
    } else { // 'd-m-Y' e 'm-d-Y'
        if (value.length > 2) {
            formattedValue = value.substring(0, 2) + '-';
            if (value.length > 4) {
                formattedValue += value.substring(2, 4) + '-';
                formattedValue += value.substring(4, 8);
            } else {
                formattedValue += value.substring(2);
            }
        } else {
            formattedValue = value;
        }
    }

    input.value = formattedValue;
    if (input.value.length == 10 || input.value.length == 0) {
        let parsedDate = $(this.SELECTORS.dateOfBirth)[0]._flatpickr.parseDate(input.value, format);
        $(this.SELECTORS.dateOfBirth)[0]._flatpickr.setDate(parsedDate);
    }
  }

  setMaxLengthBirthDatePicker() {
    $(this.SELECTORS.dateOfBirth).attr('maxlength', '10');
  }
}
